import { Injectable } from '@angular/core';

import { Observable } from 'rxjs/Observable';

import { AngularFireAuth } from 'angularfire2/auth';
import * as firebase from 'firebase';

@Injectable()
export class CloudStorageService {
  private storageRef;

  constructor(
    private afAuth: AngularFireAuth
  ) {
    this.storageRef = firebase.storage().ref();
  }

  getUserProfilePicUrl(key): firebase.Promise<string> {
    return this.storageRef.child(`users/${key}/profileImage`)
                          .getDownloadURL()
  }

  setUserProfilePic(key, file) {
    this.storageRef.child(`users/${key}/profileImage`).put(file);
  }

  getProviderLogoUrl(key) {
    return this.storageRef.child(`providers/${key}/profileImage`)
                          .getDownloadURL()
  }

  setProviderLogo(key, file) {
    this.storageRef.child(`providers/${key}/profileImage`).put(file);
  }

  setResourceFile(key, file) {
    this.storageRef.child(`resources/${key}/${file.name}`).put(file);
  }

  uploadNewsletterFile(file) {
    return this.storageRef.child(`newsletters/uploads/${file.name}`)
                          .put(file);

  }

  getNewsletterFileUrl(fileName) {
    return this.storageRef.child(`newsletters/uploads/${fileName}`)
                          .getDownloadURL();
  };

}



// WEBPACK FOOTER //
// ./src/app/cloud-storage.service.ts